import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

const DonationsSC = styled.div`
    display: flex;
    flex-direction: column;
    width: 1200px;
    margin: 40px 0px 0px;
    justify-content: center;
    align-items: center;
    ${NoTextSelectionStyles}

    .grid-container {
        display: flex;
        width: 100%;
        height: 400px;
        gap: 20px;
    }

    .section-title {
        text-align: center;
        font-size: 24px;
        letter-spacing: 2px;
        font-weight: 600;
    }

    .section-subtitle {
        text-align: center;
        margin-top: 24px;
        margin-bottom: 48px;
        font-size: 18px;
        width: 80%;
        text-align: center;
        letter-spacing: 1px;
        color: #5c5a5aff;
        line-height: 26px;
    }

    .donation-action-text {
        text-align: center;
        margin-top: 48px;
        font-size: 14px;
        width: 50%;
        text-align: center;
        letter-spacing: 1px;
        color: #292828;
        line-height: 20px;
    }

    .card {
        flex: 1;
        border-radius: 20px;
        background-size: cover;
        background-position: center;
        cursor: pointer;
        position: relative;
        transition: flex 0.5s ease, transform 0.3s ease;
        overflow: hidden;
    }

    .card.active {
        flex: 3; /* expands width */
    }

    .card:hover {
        transform: scale(1.02);
    }

    .overlay {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 20px;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
        color: white;
        opacity: 0;
        transition: opacity 0.4s ease;
    }

    .card.active .overlay {
        opacity: 1;
    }

    .overlay h3 {
        margin: 0;
        font-size: 20px;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin: 16px 0px 0px;

        .grid-container {
            display: flex;
            width: calc(100% - 16px);
            height: 150px;
            gap: 4px;
            margin: 0px 8px;
        }

        .section-title {
            text-align: center;
            font-size: 16px;
            letter-spacing: 1px;
        }

        .section-subtitle {
            margin-top: 12px;
            margin-bottom: 24px;
            font-size: 14px;
            letter-spacing: 0.75px;
            line-height: 20px;
        }

        .donation-action-text {
            margin-top: 24px;
            font-size: 12px;
            width: 80%;
            letter-spacing: 0.75px;
            line-height: 20px;
        }

        .card {
            border-radius: 8px;
        }

        .card.active {
            flex: 9; /* expands width */
        }

        .overlay {
            padding: 12px;
        }

        .card.active .overlay {
            opacity: 1;
        }

        .overlay h3 {
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.75px;
        }
    }
`;

export default DonationsSC;